// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1153":"fbe996ab","6782":"ea736662","7076":"712850c9","9884":"c1fb29b6"}[chunkId] + ".chunk.css";
};